import { render, staticRenderFns } from "./Radar.vue?vue&type=template&id=3ac05533&scoped=true&"
import script from "./Radar.vue?vue&type=script&setup=true&lang=js&"
export * from "./Radar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac05533",
  null
  
)

export default component.exports